import axios from "axios";
import { headers } from "../exports/exports";
import { dynamicFailed } from "../hooks/useToast";

export const fetchContactBanner = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_strapiUrl}/api/frcsit-contact-banners?populate=*`,
      { headers }
    );
    return response.data.data.slice(-1);
  } catch (error: any) {
    dynamicFailed(`${error.message}`);
}
};

export const fetchContactFrom = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_strapiUrl}/api/frcsit-contact-descriptions?populate=*`,
      { headers }
    );
    return response.data.data.slice(-1);
  } catch (error: any) {
    dynamicFailed(`${error.message}`);
}
};
